import { render, staticRenderFns } from "./AppScreenshot.vue?vue&type=template&id=49ab196a&scoped=true"
import script from "./AppScreenshot.vue?vue&type=script&lang=js"
export * from "./AppScreenshot.vue?vue&type=script&lang=js"
import style0 from "./AppScreenshot.vue?vue&type=style&index=0&id=49ab196a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ab196a",
  null
  
)

export default component.exports